<template>
    <div class="autoplay-timer-container" v-if="show">
        <div class="next-playback-thumbnail">
            <img v-if="nextPlayback && nextPlayback.attributes.urls.thumbnail" :src="nextPlayback.attributes.urls.thumbnail" alt="placeholder">
            <img v-else src="../../../assets/img/thumbnail.jpg" alt="placeholder">
        </div>
        <div class="description">
            <div class="label">Up next</div>
            <div class="title">{{title}}</div>
            <div class="skip-button" @click="playNext">
                <img src="../../../assets/img/skip.svg" alt="next">
                <div class="progress-wrapper" data-anim="base wrapper" :style="styles.progressWrapper">
                    <div class="progress-circle" data-anim="base left" :style="styles.progressCircleLeft"></div>
                    <div class="progress-circle" data-anim="base right" :style="styles.progressCircleRight"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as types from '../../store/actionTypes';
import { getLeftLabel, getRightLabel } from "../../helpers/streams";
const { mapGetters, mapActions } = createNamespacedHelpers('main');

export default {
    name: 'AutoplayTimer',
    data() {
        return {
            duration: 5,
            time: null,
            timer: null
        }
    },
    props: {
        show: { type: Boolean }
    },
    watch: {
        show(nextProp) {
            this.time = this.duration;
            clearInterval(this.timer);

            if(nextProp) {
                this.timer = setInterval(() => {
                    if (this.time > 1) {
                        this.time--
                    } else {
                        this.playNext();
                    }
                }, 1000)
            }
        }
    },
    methods: {
        ...mapActions({
            changeActivePlayback: types.CHANGE_ACTIVE_PLAYBACK
        }),
        playNext() {
            clearInterval(this.timer);
            this.changeActivePlayback(this.nextPlayback.id);
        }
    },
    computed: {
        ...mapGetters({
            nextPlayback: 'nextPlayback'
        }),
        title() {
            if (this.nextPlayback) {
                const { type, attributes } = this.nextPlayback;

                return `${getLeftLabel(type, attributes, attributes.name)} (${getRightLabel(type)})`;
            }

            return '';
        },
        styles() {
            return {
                progressWrapper: {
                    animationDelay: `${this.duration / 2}s`,
                },
                progressCircleLeft: {
                    animationDuration: `${this.duration}s`,
                },
                progressCircleRight: {
                    animationDuration: `${this.duration / 2}s`,
                }
            }
        }
    }
}
</script>
